import React from "react";
import { withRouter } from "tools/routerCompat";
import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";
import { ButtonCard, SearchCard } from "../../components/Maintenance";
import { MSpinner } from "../../components/Shared";
import MSectionCollection from "components/Shared/MSectionCollection";

const Components = {
  ButtonCard,
  SearchCard
};

class Maintenance extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = "Maintenance";
  }

  componentDidMount() {
    this.props.getMaintenanceSections();
  }

  render() {
    if (this.props.isFetchingMaintenanceSections) {
      return <MSpinner />;
    }
    let Component;
    return (
      <div className="maintenance padding-page-content">
        <MSectionCollection
          sections={this.props.maintenanceSections.map(ms => ({
            title: ms.title,
            children: <Stack direction="row" flexWrap="wrap" gap={2}>
                        {ms.maintenanceCards.map(card => {
                          Component = Components[card.component];
                          return (
                            <Component 
                              key={card.id} 
                              icon={card.icon}
                              title={card.title}
                              subTitle={card.subTitle}
                              className={card.component}
                              pathname={card.path}
                              history={this.props.history}
                              actionName={card.actionName}
                            />
                          );})}
                      </Stack>
          }))}
         />
      </div> 
    );
  }
}

Maintenance.propTypes = {
  history: PropTypes.object.isRequired,
  getMaintenanceSections: PropTypes.func.isRequired,
  maintenanceSections: PropTypes.array.isRequired,
  isFetchingMaintenanceSections: PropTypes.bool.isRequired,
};

export default withRouter(Maintenance);